"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataItem_1 = require("../common/base/DataItem");
var ConditionIn_1 = require("./ConditionIn");
var lodash_1 = require("lodash");
var Field_1 = require("../../constants/Field");
var DeepCopy_1 = require("../common/lib/DeepCopy");
var DataType_1 = require("../common/base/DataType");
var FunctionInputs = /** @class */ (function () {
    function FunctionInputs() {
    }
    FunctionInputs.fromJson = function (inputsObject, isInstance, objectInstanceIds) {
        var functionInputs = new FunctionInputs();
        var pureInputs = DeepCopy_1.deepCopy(inputsObject);
        delete pureInputs[Field_1.FIELD.CONDITIONS];
        delete pureInputs[Field_1.FIELD.ALARMMAPPING];
        functionInputs.inputs = FunctionInputs.fromJsonToInputs(pureInputs, isInstance, objectInstanceIds);
        if (inputsObject[Field_1.FIELD.CONDITIONS]) {
            functionInputs.conditions = FunctionInputs.fromJsonToConditions(inputsObject[Field_1.FIELD.CONDITIONS]);
        }
        return functionInputs;
    };
    /**
     * @param pureInputsJson json object having only input fields. No conditions field
     * @param isInstance True when json is an instance
     * @param objectInstanceIds Object id/s of object instance/s used, will be empty if not used
     */
    FunctionInputs.fromJsonToInputs = function (pureInputsJson, isInstance, objectInstanceIds) {
        var inputs = lodash_1.map(Object.keys(pureInputsJson), function (inputName) {
            var dataItem = DataItem_1.DataItem.fromJson(inputName, pureInputsJson[inputName]);
            if ((!dataItem.link) && (!dataItem.value)) {
                dataItem.link = '';
            }
            else {
                dataItem.removeObjectId(isInstance, objectInstanceIds);
            }
            return dataItem;
        });
        return inputs;
    };
    /**
     * @param conditionsJson conditions json
     */
    FunctionInputs.fromJsonToConditions = function (conditionsJson) {
        var conditions = lodash_1.map(Object.keys(conditionsJson), function (conditionName) {
            return ConditionIn_1.ConditionIn.fromJson(conditionName, conditionsJson[conditionName]);
        });
        return conditions;
    };
    FunctionInputs.clearConnections = function (inputs, connectionGuid) {
        lodash_1.map(Object.keys(inputs), function (inputName) {
            if ((inputName === Field_1.FIELD.CONDITIONS) || (inputName === Field_1.FIELD.ALARMMAPPING)) {
                return;
            }
            if (!inputs[inputName][Field_1.FIELD.LINK]) {
                return;
            }
            if (inputs[inputName][Field_1.FIELD.DATATYPE] === DataType_1.DataType.array) {
                var linkValues = JSON.parse(inputs[inputName][Field_1.FIELD.LINK]);
                var unlinkedValues_1 = [];
                lodash_1.map(linkValues, function (linkValue) {
                    if (!(linkValue.includes(connectionGuid))) {
                        unlinkedValues_1.push(linkValue);
                    }
                });
                if (unlinkedValues_1.length === 0) {
                    delete inputs[inputName][Field_1.FIELD.LINK];
                }
                else {
                    inputs[inputName][Field_1.FIELD.LINK] = JSON.stringify(unlinkedValues_1);
                }
            }
            else if (inputs[inputName][Field_1.FIELD.LINK].includes(connectionGuid)) {
                delete inputs[inputName][Field_1.FIELD.LINK];
            }
        });
        return inputs;
    };
    FunctionInputs.updateConnections = function (inputs, connectionGuids, targetObjectType) {
        lodash_1.map(Object.keys(inputs), function (inputName) {
            if ((inputName === Field_1.FIELD.CONDITIONS) || (inputName === Field_1.FIELD.ALARMMAPPING)) {
                return;
            }
            if (!inputs[inputName][Field_1.FIELD.LINK]) {
                return;
            }
            if (inputs[inputName][Field_1.FIELD.DATATYPE] === DataType_1.DataType.array) {
                var linkValues = JSON.parse(inputs[inputName][Field_1.FIELD.LINK]);
                var unlinkedValues_2 = [];
                lodash_1.map(linkValues, function (linkValue) {
                    var connectedGuid = lodash_1.find(connectionGuids, function (o) { return linkValue.includes(o); });
                    if (connectedGuid === undefined) {
                        unlinkedValues_2.push(linkValue);
                        return;
                    }
                    var linkedVariable = linkValue.split('/');
                    var linkedVariableName = linkedVariable[linkedVariable.length - 1];
                    var nodes = lodash_1.get(targetObjectType, "variables.nodes", []);
                    var matchedPath = nodes.length > 0 ? targetObjectType.variables.getPathForMatchingVariable(linkedVariableName, inputs[inputName][Field_1.FIELD.ITEMS], connectedGuid) : null;
                    if (matchedPath !== null) {
                        unlinkedValues_2.push(matchedPath);
                    }
                });
                if (unlinkedValues_2.length === 0) {
                    delete inputs[inputName][Field_1.FIELD.LINK];
                }
                else {
                    inputs[inputName][Field_1.FIELD.LINK] = JSON.stringify(unlinkedValues_2);
                }
            }
            else {
                var connectedGuid = lodash_1.find(connectionGuids, function (o) { return inputs[inputName][Field_1.FIELD.LINK].includes(o); });
                if (connectedGuid === undefined) {
                    return;
                }
                var linkedVariable = inputs[inputName][Field_1.FIELD.LINK].split('/');
                var linkedVariableName = linkedVariable[linkedVariable.length - 1];
                var nodes = lodash_1.get(targetObjectType, "variables.nodes", []);
                var matchedPath = nodes.length > 0 ? targetObjectType.variables.getPathForMatchingVariable(linkedVariableName, inputs[inputName][Field_1.FIELD.DATATYPE], connectedGuid) : null;
                if (matchedPath !== null) {
                    inputs[inputName][Field_1.FIELD.LINK] = matchedPath;
                }
                else {
                    delete inputs[inputName][Field_1.FIELD.LINK];
                }
            }
        });
        return inputs;
    };
    FunctionInputs.prototype.toJson = function (includeOnlyValueOrLink) {
        var json = {};
        json = Object.assign(json, this.inputsToJson(includeOnlyValueOrLink), this.conditionsToJson(includeOnlyValueOrLink));
        return json;
    };
    FunctionInputs.prototype.inputsToJson = function (includeOnlyValueOrLink) {
        var json = Object.create(null);
        lodash_1.map(this.inputs, function (input) {
            var _a;
            var inputDataItemJson = input.toJson(includeOnlyValueOrLink);
            if (!inputDataItemJson[Field_1.FIELD.VALUE]) {
                inputDataItemJson[Field_1.FIELD.VALUE] = input.getDefaultItemValue();
            }
            json = Object.assign(json, (_a = {}, _a[input.name] = inputDataItemJson, _a));
        });
        return json;
    };
    FunctionInputs.prototype.conditionsToJson = function (includeOnlyValueOrLink) {
        var json = {};
        if (this.conditions !== undefined) {
            lodash_1.map(this.conditions, function (condition) {
                json[Field_1.FIELD.CONDITIONS] = Object.assign({}, json[Field_1.FIELD.CONDITIONS], condition.toJson(includeOnlyValueOrLink));
            });
        }
        if (lodash_1.isEmpty(json[Field_1.FIELD.CONDITIONS])) {
            delete json[Field_1.FIELD.CONDITIONS];
        }
        return json;
    };
    return FunctionInputs;
}());
exports.FunctionInputs = FunctionInputs;
//# sourceMappingURL=FunctionInputs.js.map